import { render } from "./CrStepSurface5Content.vue?vue&type=template&id=1ea50353&scoped=true"
import script from "./CrStepSurface5Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface5Content.vue?vue&type=script&lang=js"

import "./CrStepSurface5Content.vue?vue&type=style&index=0&id=1ea50353&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea50353"]])

export default __exports__